<template>
  <v-card class="pa-6">
    <div class="pa-2 d-flex justify-center align-center" v-if="loading">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <div v-else>
      <h3 class="text-center mb-4">
        <strong>
          Adicionar equipamentos a um Template de Checklist(Rotina de inspeção)
        </strong>
      </h3>

      <v-form ref="form">
        <v-select
          v-model="templateId"
          :rules="[(v) => !!v || 'Selecione o template']"
          :items="templates.filter((x) => x.withoutEquipment == false)"
          item-text="name"
          item-value="id"
          menu-props="auto"
          placeholder="Selecione o template"
          hide-details="auto"
          prepend-inner-icon="mdi-file-document"
          single-line
          outlined
          class="primary-input"
        ></v-select>
      </v-form>

      <div class="mt-4 d-flex justify-end">
        <v-btn class="primary-button mr-0" depressed @click="submit">
          Salvar
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  props: {
    equipmentSelected: Array,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getTemplates()
  },

  data() {
    return {
      institutionId: '',
      apiService: new ApiService(),
      templates: [],
      templateId: '',
      loading: false,
    }
  },

  methods: {
    getTemplates() {
      this.loading = true
      this.apiService
        .get(
          `InspectionRoutineChecklistTemplate/${this.institutionId}/byType/1`
        )
        .then((response) => {
          this.templates = response.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const model = {
          templateId: this.templateId,
          equipmentIds: this.equipmentSelected.map((x) => x.id),
        }

        this.apiService
          .post('InspectionRoutineChecklistTemplate/add/equipments', model)
          .then(() => {
            this.$emit('close')
            this.$emit('clearSelection')
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style></style>
